import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, ArrowRight } from 'lucide-react';

const serviceAreas = [
  { name: 'Florida Statewide', link: '/lady-bird-deed-florida', description: 'Serving all 67 counties' },
  { name: 'Sarasota', link: '/lady-bird-deed-sarasota', description: 'Sarasota County' },
  { name: 'Venice', link: '/lady-bird-deed-venice-fl', description: 'Local office' },
  { name: 'Tampa', link: '/lady-bird-deed-tampa-fl', description: 'Hillsborough County' },
  { name: 'Orlando', link: '/lady-bird-deed-orlando-fl', description: 'Orange County' },
  { name: 'Fort Lauderdale', link: '/lady-bird-deed-fort-lauderdale', description: 'Broward County' },
];

const ServiceAreasSection = () => {
  return (
    <section className="py-16 bg-[#0f0f0f]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="font-sans text-xs tracking-[0.3em] uppercase text-[#c9a87c] mb-4 block">
            Service Areas
          </span>
          <h2 className="font-serif text-3xl md:text-4xl text-[#faf9f7] mb-4">
            Lady Bird Deed Attorney <span className="text-gradient-gold">Serving All Florida</span>
          </h2>
          <p className="font-sans text-[#faf9f7]/60 max-w-2xl mx-auto">
            Our Venice office serves homeowners throughout Florida. Remote service available statewide — no travel required.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {serviceAreas.map((area, index) => (
            <Link
              key={index}
              to={area.link}
              className="group flex items-center gap-4 p-5 bg-[#141414] border border-[#c9a87c]/10 rounded-lg hover:border-[#c9a87c]/30 transition-all"
            >
              <div className="w-10 h-10 rounded-lg bg-[#c9a87c]/10 flex items-center justify-center flex-shrink-0 group-hover:bg-[#c9a87c]/20 transition-colors">
                <MapPin className="w-5 h-5 text-[#c9a87c]" />
              </div>
              <div className="flex-1">
                <h3 className="font-sans font-medium text-[#faf9f7] group-hover:text-[#c9a87c] transition-colors">
                  {area.name}
                </h3>
                <p className="font-sans text-sm text-[#faf9f7]/50">{area.description}</p>
              </div>
              <ArrowRight className="w-5 h-5 text-[#c9a87c]/50 group-hover:text-[#c9a87c] transition-colors" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceAreasSection;
